'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLockClosed = function TiLockClosed(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 16.7h-1.6v-3.4c0-3.6-3-6.6-6.7-6.6s-6.7 3-6.7 6.6v3.4h-1.6c-1.9 0-3.4 1.5-3.4 3.3v11.7c0 1.8 1.5 3.3 3.4 3.3h16.6c1.9 0 3.4-1.5 3.4-3.3v-11.7c0-1.8-1.5-3.3-3.4-3.3z m-8.3 13.8c-1.2 0-2.2-1-2.2-2.2s1-2.1 2.2-2.1 2.2 0.9 2.2 2.1-1 2.2-2.2 2.2z m3.3-12.2h-6.6v-5c0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3v5z' })
        )
    );
};

exports.default = TiLockClosed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/lock-closed.js
// module id = 2104
// module chunks = 0